export default __webpack_public_path__ + "static/media/photo--sm--huda-5.3157ade5.jpg";